import { TradeToken } from "@utils/metamask";
import { TOKEN_ADDRESS } from "src/config";

export const fugaziToken: TradeToken = {
  address: TOKEN_ADDRESS,
  image: "/images/logos/fugazi-logo-256.png",
  decimals: 9,
  symbol: "FGZ"
};
